import types from '@constants/action-types';
import { reducerFactory } from '@factories';

export const initialState = {
  isLoading: false,
  results: [],
  selected: [],
  countries: [],
  cleared: false,
  getCountriesPending: false,
  getCountriesSuccess: false,
  error: null,
};
export default reducerFactory(initialState, {
  [types.ADD_SELECTED_COUNTRIES]: (state, action) => ({
    ...state,
    cleared: false,
    selected: !state.cleared ? action.response.countries : [],
  }),
  [types.SELECT_COUNTRY]: (state, action) => ({
    ...state,
    selected: [...state.selected, ...action.response.country],
  }),
  [types.REMOVE_COUNTRY]: (state, action) => ({
    ...state,
    selected: state.selected.filter(item => item !== action.response.country),
  }),
  [types.REMOVE_ALL_COUNTRIES]: state => ({
    ...state,
    cleared: true,
    selected: [],
  }),
  [types.GET_COUNTRIES_REQUEST]: state => ({ ...state, getCountriesPending: true, error: null }),
  [types.GET_COUNTRIES_SUCCESS]: (state, { response }) => ({
    ...state,
    getCountriesPending: false,
    getCountriesSuccess: true,
    ...response.countries,
  }),
  [types.GET_COUNTRIES_FAILURE]: (state, { response }) => ({
    ...state,
    getCountriesPending: false,
    error: response.error,
  }),
});
